import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { GhostButton, NormalButton } from '@components/General/Button';
import { useQRScreenViewModel } from '../view-models/QRCodeScreenViewModel';
import { isMobile } from 'react-device-detect';
import { MobileWrapperScreen } from './MobileWrapperScreen';
import { Text } from "@components/General/Texts"
import { useEffect } from "react";

const environment = process.env.REACT_APP_FRONT_ENV || 'PROD';
let phoneNumber = ""
if (environment == "PROD") {
    phoneNumber = "5491157657668"
} else {
    phoneNumber = "5491151169134"
}

export const MobileQRCodeScreen: React.FC = () => {
    const {
        qrCodeUrl,
        qpId,
        isLoading,
        handleAlreadyDone,
        viewDidAppear,
    } = useQRScreenViewModel();

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once

    const handleAddWhatsAppClick = () => {
        const message = encodeURIComponent("Hola! Vamos a probar fichar por WhatsApp en ##%s##".localized(qpId))
        window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank')
    }

    return (
        <MobileWrapperScreen>
            <VerticalContainer gap={designSystem.gapNone}>
                <H2Title text={"Agrega el contacto de WhatsApp".localized()}/>
                <Subtitle text={"Ahora que habilitamos tu número de teléfono y agregamos tu ubicación actual como válida para fichar, tenes todo listo para probar Qontact!".localized()}/>
            </VerticalContainer>

            {qpId && (
                <p style={{ 
                    textAlign: 'center',
                    color: designSystem.colorTextSecondary,
                    fontSize: designSystem.fontSizeSm,
                    margin: 0,
                }}>
                    ID: {qpId}
                </p>
            )}

            <Text text={"Vamos a abrir WhatsApp para que hagas tu fichada y luego vas a volver a ésta página para ver el estado de tu fichada.".localized()} />
            <VerticalContainer alignment={'center'}>
                <NormalButton 
                    text={"Fichar con WhatsApp".localized()}
                    width={"100%"}
                    onClick={handleAddWhatsAppClick}
                    disabled={isLoading}
                />
                <GhostButton
                    text={"Ya termine la fichada".localized()}
                    width={"100%"}
                    onClick={handleAlreadyDone}
                    disabled={isLoading}
                />
            </VerticalContainer>
        </MobileWrapperScreen>
    );
};